"use strict";

require("core-js/modules/es.array.from");

var curry = require("./curry.js");

var takeAll = require("./takeAll.js");

var go = require("./go.js");

var map = require("./map.js");

var append = require("./append.js");

var apply = require("./apply.js");

var sliceL = require("../Lazy/sliceL.js");

module.exports = curry(function slice(start, end, iter) {
  if (iter === undefined) return slice(start, Infinity, end);

  if (start < 0 || end < 0) {
    iter = Array.from(iter);
  }

  return go([start, end], map(i => i < 0 ? i + iter.length : i), append(iter), apply(sliceL), takeAll);
});